/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetInstanceSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetInstanceSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetInstanceSecurityOption3 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetInstanceSecurityOption4 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type GetInstanceSecurity = {
  option1?: GetInstanceSecurityOption1 | undefined;
  option2?: GetInstanceSecurityOption2 | undefined;
  option3?: GetInstanceSecurityOption3 | undefined;
  option4?: GetInstanceSecurityOption4 | undefined;
};

export type GetInstanceRequest = {
  /**
   * The slug of the toolset to load
   */
  toolsetSlug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
};

/** @internal */
export type GetInstanceSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetInstanceSecurityOption1$outboundSchema: z.ZodMiniType<
  GetInstanceSecurityOption1$Outbound,
  GetInstanceSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getInstanceSecurityOption1ToJSON(
  getInstanceSecurityOption1: GetInstanceSecurityOption1,
): string {
  return JSON.stringify(
    GetInstanceSecurityOption1$outboundSchema.parse(getInstanceSecurityOption1),
  );
}

/** @internal */
export type GetInstanceSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetInstanceSecurityOption2$outboundSchema: z.ZodMiniType<
  GetInstanceSecurityOption2$Outbound,
  GetInstanceSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getInstanceSecurityOption2ToJSON(
  getInstanceSecurityOption2: GetInstanceSecurityOption2,
): string {
  return JSON.stringify(
    GetInstanceSecurityOption2$outboundSchema.parse(getInstanceSecurityOption2),
  );
}

/** @internal */
export type GetInstanceSecurityOption3$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetInstanceSecurityOption3$outboundSchema: z.ZodMiniType<
  GetInstanceSecurityOption3$Outbound,
  GetInstanceSecurityOption3
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getInstanceSecurityOption3ToJSON(
  getInstanceSecurityOption3: GetInstanceSecurityOption3,
): string {
  return JSON.stringify(
    GetInstanceSecurityOption3$outboundSchema.parse(getInstanceSecurityOption3),
  );
}

/** @internal */
export type GetInstanceSecurityOption4$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const GetInstanceSecurityOption4$outboundSchema: z.ZodMiniType<
  GetInstanceSecurityOption4$Outbound,
  GetInstanceSecurityOption4
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function getInstanceSecurityOption4ToJSON(
  getInstanceSecurityOption4: GetInstanceSecurityOption4,
): string {
  return JSON.stringify(
    GetInstanceSecurityOption4$outboundSchema.parse(getInstanceSecurityOption4),
  );
}

/** @internal */
export type GetInstanceSecurity$Outbound = {
  Option1?: GetInstanceSecurityOption1$Outbound | undefined;
  Option2?: GetInstanceSecurityOption2$Outbound | undefined;
  Option3?: GetInstanceSecurityOption3$Outbound | undefined;
  Option4?: GetInstanceSecurityOption4$Outbound | undefined;
};

/** @internal */
export const GetInstanceSecurity$outboundSchema: z.ZodMiniType<
  GetInstanceSecurity$Outbound,
  GetInstanceSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetInstanceSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetInstanceSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => GetInstanceSecurityOption3$outboundSchema),
    ),
    option4: z.optional(
      z.lazy(() => GetInstanceSecurityOption4$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
      option4: "Option4",
    });
  }),
);

export function getInstanceSecurityToJSON(
  getInstanceSecurity: GetInstanceSecurity,
): string {
  return JSON.stringify(
    GetInstanceSecurity$outboundSchema.parse(getInstanceSecurity),
  );
}

/** @internal */
export type GetInstanceRequest$Outbound = {
  toolset_slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
};

/** @internal */
export const GetInstanceRequest$outboundSchema: z.ZodMiniType<
  GetInstanceRequest$Outbound,
  GetInstanceRequest
> = z.pipe(
  z.object({
    toolsetSlug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolsetSlug: "toolset_slug",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramKey: "Gram-Key",
      gramChatSession: "Gram-Chat-Session",
    });
  }),
);

export function getInstanceRequestToJSON(
  getInstanceRequest: GetInstanceRequest,
): string {
  return JSON.stringify(
    GetInstanceRequest$outboundSchema.parse(getInstanceRequest),
  );
}
